<!-- src/components/TermsAndConditionsUpdate.vue -->
<template>
  <div class="cookie-div" v-if="show_terms_conditions">
    <div class="terms-fixed p-2">
      <p>{{ $t('terms_conditions_updated') }}</p>
      <div class="btn-cookie">
        <button
          v-on:click="readTermsConditionsClick"
          class="btn btn-border btn-white btn-sm btn-succes"
        >
          <span>{{ $t('close') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import User from '../services/user'

export default {
  name: 'TermsAndConditionsUpdate',
  data () {
    return {
      timeout: null,
      show_terms_conditions: false
    }
  },
  mounted () {
    // Start a 1-minute timer when the component is mounted
    this.startTimeout()
  },
  created () {
    this.user = this.$user
    User.checkTutorial('terms_jan_9_25').then(response => {
      if (response.data.show_tutorial) {
        this.show_terms_conditions = true
        this.$forceUpdate()
      }
    })
  },
  methods: {
    readTermsConditionsClick () {
      // Clear the timeout in case the user clicks before 1 minute
      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      this.show_terms_conditions = false
    },
    startTimeout () {
      // Set a timeout of 1 minute (60,000ms)
      this.timeout = setTimeout(() => {
        this.readTermsConditionsClick() // Automatically trigger the action after 1 minute
      }, 30000)
    }
  },
  beforeDestroy () {
    // Clear the timeout when the component is destroyed
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}
</script>

<style scoped>
.terms-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #5714ff;
  font-family: 'Poppins';
  z-index: 999999;
  opacity: 0.7;
}

.terms-fixed p{
  color: #FFFFFF;
  display: inline-block;
  margin: 0;
  vertical-align: sub;
  font-size: 11px !important;
}

.terms-fixed .btn-cookie{
  float: right;
}

.terms-fixed .btn {
  margin-left: 5px;
}
.terms-fixed .btn.btn-succes{
  min-width: 90px;
}

@media screen and (max-width: 992px) {
  .terms-fixed p{
    display: block;
  }
  .terms-fixed .btn-cookie{
    float: none;
  }
  .terms-fixed .btn {
    margin-left: 0;
    margin-right: 5px;
  }
  .terms-fixed .btn.btn-succes{
    float: right;
  }
  .terms-fixed p{
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TermsAndConditionsUpdate.vue